import { getTranslatedText } from '@nile/components/src';

const days = [
  {
    day: 'Monday',
    label: 'Monday',
    value: 'monday',
    startHour: {},
    endHour: {},
    selected: false
  },
  {
    day: 'Tuesday',
    label: 'Tuesday',
    value: 'tuesday',
    startHour: {},
    selected: false,
    endHour: {}
  },
  {
    day: 'Wednesday',
    label: 'Wednesday',
    value: 'wednesday',
    startHour: {},
    selected: false,
    endHour: {}
  },
  {
    day: 'Thursday',
    label: 'Thursday',
    value: 'thursday',
    startHour: {},
    selected: false,
    endHour: {}
  },
  {
    day: 'Friday',
    label: 'Friday',
    value: 'friday',
    startHour: {},
    selected: false,
    endHour: {}
  },
  {
    day: 'Saturday',
    label: 'Saturday',
    value: 'saturday',
    startHour: {},
    selected: false,
    endHour: {}
  }
];

const hours = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6', value: '6' },
  { label: '7', value: '7' },
  { label: '8', value: '8' },
  { label: '9', value: '9' },
  { label: '10', value: '10' },
  { label: '11', value: '11' },
  { label: '12', value: '12' }
];

const hoursType = [
  { label: 'PM', value: 'PM' },
  { label: 'AM', value: 'AM' }
];

const months = [
  'january',
  'feburary',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december'
];

const monthOptions = (intl) => {
  const MONTH_OPTIONS = [
    {
      name: 'JANUARY',
      label: getTranslatedText(intl, 'admin.holidayManagement.month.jan'),
      value: 'JAN',
      id: 1
    },
    {
      name: 'FEBRUARY',
      label: getTranslatedText(intl, 'admin.holidayManagement.month.feb'),
      value: 'FEB',
      id: 2
    },
    {
      name: 'MARCH',
      label: getTranslatedText(intl, 'admin.holidayManagement.month.mar'),
      value: 'MAR',
      id: 3
    },
    {
      name: 'APRIL',
      label: getTranslatedText(intl, 'admin.holidayManagement.month.apr'),
      value: 'APR',
      id: 4
    },
    {
      name: 'MAY',
      label: getTranslatedText(intl, 'admin.holidayManagement.month.may'),
      value: 'MAY',
      id: 5
    },
    {
      name: 'JUNE',
      label: getTranslatedText(intl, 'admin.holidayManagement.month.jun'),
      value: 'JUN',
      id: 6
    },
    {
      name: 'JULY',
      label: getTranslatedText(intl, 'admin.holidayManagement.month.jul'),
      value: 'JUL',
      id: 7
    },
    {
      name: 'AUGUST',
      label: getTranslatedText(intl, 'admin.holidayManagement.month.aug'),
      value: 'AUG',
      id: 8
    },
    {
      name: 'SEPTEMBER',
      label: getTranslatedText(intl, 'admin.holidayManagement.month.sep'),
      value: 'SEP',
      id: 9
    },
    {
      name: 'OCTOBER',
      label: getTranslatedText(intl, 'admin.holidayManagement.month.oct'),
      value: 'OCT',
      id: 10
    },
    {
      name: 'NOVEMBER',
      label: getTranslatedText(intl, 'admin.holidayManagement.month.nov'),
      value: 'NOV',
      id: 11
    },
    {
      name: 'DECEMBER',
      label: getTranslatedText(intl, 'admin.holidayManagement.month.dec'),
      value: 'DEC',
      id: 12
    }
  ];
  return MONTH_OPTIONS;
};

function getMonths() {
  var months = [
    { name: 'JANUARY', label: 'JAN' },
    { name: 'FEBRUARY', label: 'FEB' },
    { name: 'MARCH', label: 'MAR' },
    { name: 'APRIL', label: 'APR' },
    { name: 'MAY', label: 'MAY' },
    { name: 'JUNE', label: 'JUN' },
    { name: 'JULY', label: 'JUL' },
    { name: 'AUGUST', label: 'AUG' },
    { name: 'SEPTEMBER', label: 'SEP' },
    { name: 'OCTOBER', label: 'OCT' },
    { name: 'NOVEMBER', label: 'NOV' },
    { name: 'DECEMBER', label: 'DEC' }
  ];
  return months;
}

function getYears() {
  const year = new Date().getFullYear();
  const yearsInfo = [];
  let years = Array.from(new Array(5), (v, i) => year + i);
  for (let i = 0; i < years.length; i++) {
    yearsInfo.push({ name: years[i], label: years[i], value: years[i] });
  }
  return yearsInfo;
}

const DAY_OPTIONS = [
  {
    name: '0',
    unit: 'DAY',
    value: 0,
    label: '0',
    quantity: 0
  },
  {
    name: '1',
    unit: 'DAY',
    value: 1,
    label: '1',
    quantity: 1
  },
  {
    name: '2',
    unit: 'DAY',
    value: 2,
    label: '2',
    quantity: 2
  },
  {
    name: '3',
    unit: 'DAY',
    value: 3,
    label: '3',
    quantity: 3
  },
  {
    name: '4',
    unit: 'DAY',
    value: 4,
    label: '4',
    quantity: 4
  },
  {
    name: '5',
    unit: 'DAY',
    value: 5,
    label: '5',
    quantity: 5
  },
  {
    name: '6',
    unit: 'DAY',
    value: 6,
    label: '6',
    quantity: 6
  },
  {
    name: '7',
    unit: 'DAY',
    value: 7,
    label: '7',
    quantity: 7
  },
  {
    name: '8',
    unit: 'DAY',
    value: 8,
    label: '8',
    quantity: 8
  },
  {
    name: '9',
    unit: 'DAY',
    value: 9,
    label: '9',
    quantity: 9
  },
  {
    name: '10',
    unit: 'DAY',
    value: 10,
    label: '10',
    quantity: 10
  },
  {
    name: '11',
    unit: 'DAY',
    value: 11,
    label: '11',
    quantity: 11
  },
  {
    name: '12',
    unit: 'DAY',
    value: 12,
    label: '12',
    quantity: 12
  },
  {
    name: '13',
    unit: 'DAY',
    value: 13,
    label: '13',
    quantity: 13
  },
  {
    name: '14',
    unit: 'DAY',
    value: 14,
    label: '14',
    quantity: 14
  },
  {
    name: '15',
    unit: 'DAY',
    value: 15,
    label: '15',
    quantity: 15
  },
  {
    name: '16',
    unit: 'DAY',
    value: 16,
    label: '16',
    quantity: 16
  },
  {
    name: '17',
    unit: 'DAY',
    value: 17,
    label: '17',
    quantity: 17
  },
  {
    name: '18',
    unit: 'DAY',
    value: 18,
    label: '18',
    quantity: 18
  },
  {
    name: '19',
    unit: 'DAY',
    value: 19,
    label: '19',
    quantity: 19
  },
  {
    name: '20',
    unit: 'DAY',
    value: 20,
    label: '20',
    quantity: 20
  },
  {
    name: '21',
    unit: 'DAY',
    value: 21,
    label: '21',
    quantity: 21
  },
  {
    name: '22',
    unit: 'DAY',
    value: 22,
    label: '22',
    quantity: 22
  },
  {
    name: '23',
    unit: 'DAY',
    value: 23,
    label: '23',
    quantity: 23
  },
  {
    name: '24',
    unit: 'DAY',
    value: 24,
    label: '24',
    quantity: 24
  },
  {
    name: '25',
    unit: 'DAY',
    value: 25,
    label: '25',
    quantity: 25
  },
  {
    name: '26',
    unit: 'DAY',
    value: 26,
    label: '26',
    quantity: 26
  },
  {
    name: '27',
    unit: 'DAY',
    value: 27,
    label: '27',
    quantity: 27
  },
  {
    name: '28',
    unit: 'DAY',
    value: 28,
    label: '28',
    quantity: 28
  },
  {
    name: '29',
    unit: 'DAY',
    value: 29,
    label: '29',
    quantity: 29
  },
  {
    name: '30',
    unit: 'DAY',
    value: 30,
    label: '30',
    quantity: 30
  }
];

const HOUR_OPTIONS = [
  {
    name: '0',
    unit: 'HOUR',
    value: 0,
    label: '0',
    quantity: 0
  },
  {
    name: '1',
    unit: 'HOUR',
    value: 1,
    label: '1',
    quantity: 1
  },
  {
    name: '2',
    unit: 'HOUR',
    value: 2,
    label: '2',
    quantity: 2
  },
  {
    name: '3',
    unit: 'HOUR',
    value: 3,
    label: '3',
    quantity: 3
  },
  {
    name: '4',
    unit: 'HOUR',
    value: 4,
    label: '4',
    quantity: 4
  },
  {
    name: '5',
    unit: 'HOUR',
    value: 5,
    label: '5',
    quantity: 5
  },
  {
    name: '6',
    unit: 'HOUR',
    value: 6,
    label: '6',
    quantity: 6
  },
  {
    name: '7',
    unit: 'HOUR',
    value: 7,
    label: '7',
    quantity: 7
  },
  {
    name: '8',
    unit: 'HOUR',
    value: 8,
    label: '8',
    quantity: 8
  },
  {
    name: '9',
    unit: 'HOUR',
    value: 9,
    label: '9',
    quantity: 9
  },
  {
    name: '10',
    unit: 'HOUR',
    value: 10,
    label: '10',
    quantity: 10
  },
  {
    name: '11',
    unit: 'HOUR',
    value: 11,
    label: '11',
    quantity: 11
  },
  {
    name: '12',
    unit: 'HOUR',
    value: 12,
    label: '12',
    quantity: 12
  },
  {
    name: '13',
    unit: 'HOUR',
    value: 13,
    label: '13',
    quantity: 13
  },
  {
    name: '14',
    unit: 'HOUR',
    value: 14,
    label: '14',
    quantity: 14
  },
  {
    name: '15',
    unit: 'HOUR',
    value: 15,
    label: '15',
    quantity: 15
  },
  {
    name: '16',
    unit: 'HOUR',
    value: 16,
    label: '16',
    quantity: 16
  },
  {
    name: '17',
    unit: 'HOUR',
    value: 17,
    label: '17',
    quantity: 17
  },
  {
    name: '18',
    unit: 'HOUR',
    value: 18,
    label: '18',
    quantity: 18
  },
  {
    name: '19',
    unit: 'HOUR',
    value: 19,
    label: '19',
    quantity: 19
  },
  {
    name: '20',
    unit: 'HOUR',
    value: 20,
    label: '20',
    quantity: 20
  },
  {
    name: '21',
    unit: 'HOUR',
    value: 21,
    label: '21',
    quantity: 21
  },
  {
    name: '22',
    unit: 'HOUR',
    value: 22,
    label: '22',
    quantity: 22
  },
  {
    name: '23',
    unit: 'HOUR',
    value: 23,
    label: '23',
    quantity: 23
  },
  {
    name: '24',
    unit: 'HOUR',
    value: 24,
    label: '24',
    quantity: 24
  }
];

const MINUTE_OPTIONS = [
  {
    name: '0',
    unit: 'MINUTE',
    value: 0,
    label: '0',
    quantity: 0
  },
  {
    name: '5',
    unit: 'MINUTE',
    value: 5,
    label: '5',
    quantity: 5
  },
  {
    name: '10',
    unit: 'MINUTE',
    value: 10,
    label: '10',
    quantity: 10
  },
  {
    name: '15',
    unit: 'MINUTE',
    value: 15,
    label: '15',
    quantity: 15
  },
  {
    name: '20',
    unit: 'MINUTE',
    value: 20,
    label: '20',
    quantity: 20
  },
  {
    name: '25',
    unit: 'MINUTE',
    value: 25,
    label: '25',
    quantity: 25
  },
  {
    name: '30',
    unit: 'MINUTE',
    value: 30,
    label: '30',
    quantity: 30
  },
  {
    name: '35',
    unit: 'MINUTE',
    value: 35,
    label: '35',
    quantity: 35
  },
  {
    name: '40',
    unit: 'MINUTE',
    value: 40,
    label: '40',
    quantity: 40
  },
  {
    name: '45',
    unit: 'MINUTE',
    value: 45,
    label: '45',
    quantity: 45
  },
  {
    name: '50',
    unit: 'MINUTE',
    value: 50,
    label: '50',
    quantity: 50
  },
  {
    name: '55',
    unit: 'MINUTE',
    value: 55,
    label: '55',
    quantity: 55
  }
];

export {
  days,
  hours,
  hoursType,
  months,
  getMonths,
  getYears,
  DAY_OPTIONS,
  MINUTE_OPTIONS,
  HOUR_OPTIONS,
  monthOptions
};
